export default function Hero() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image - Desktop */}
      <div 
        className="hidden md:block absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/d5416ef1f2dfe0a1b1b5fed6571e726d.jpg)'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Background Image - Mobile */}
      <div 
        className="md:hidden absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=modern%20professional%20logistics%20warehouse%20with%20elegant%20floral%20arrangements%20and%20delivery%20trucks%20showcasing%20efficient%20flower%20transportation%20services%20with%20clean%20organized%20space%20featuring%20fresh%20blooms%20in%20climate%20controlled%20environment%20and%20professional%20delivery%20vehicles%20ready%20for%20transport%20creating%20a%20sophisticated%20business%20atmosphere%20with%20natural%20lighting%20and%20contemporary%20design%20elements%20emphasizing%20reliability%20and%20quality%20service&width=800&height=1200&seq=hero-bg-logistics-mobile&orientation=portrait)'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <div className="bg-white/30 backdrop-blur-md rounded-3xl p-8 md:p-12 shadow-2xl border border-white/30">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 bg-gradient-to-r from-black to-emerald-600 bg-clip-text text-transparent">
            Transport et Livraison de Fleurs Professionnels
          </h1>
          <p className="text-lg md:text-xl lg:text-2xl mb-10 max-w-3xl mx-auto bg-gradient-to-r from-black to-emerald-600 bg-clip-text text-transparent font-semibold">
            Experts en logistique florale depuis 2020. Solutions sur mesure pour fleuristes, grossistes et événements. Service 24/7 dans toute la France.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center flex-wrap">
            <button 
              onClick={() => scrollToSection('services')}
              className="bg-emerald-600 text-white px-6 py-3 rounded-full text-base font-semibold hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="bg-emerald-600 text-white px-6 py-3 rounded-full text-base font-semibold hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              À propos
            </button>
            <button 
              onClick={() => scrollToSection('advantages')}
              className="bg-emerald-600 text-white px-6 py-3 rounded-full text-base font-semibold hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Avantages
            </button>
            <button 
              onClick={() => scrollToSection('localisation')}
              className="bg-emerald-600 text-white px-6 py-3 rounded-full text-base font-semibold hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Localisation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}